// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "input-2xk79";
var _4 = "input_focused-3ODvD";
var _5 = "input_underline-1WPDF";
export { _1 as "__esModule", _2 as "mobile", _3 as "input", _4 as "input_focused", _5 as "input_underline" }
export default { "__esModule": _1, "mobile": _2, "input": _3, "input_focused": _4, "input_underline": _5 }
